export default "__VITE_ASSET__95dfec2a__"